export class ImportSyncDataFilterSettingsModel {
  public name: string;
  public additionalTitle: string;
  public importDataStatusId?: number;
  public syncDataStatusId?: number;
}